// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "fonts/" + {"84":"font-geometric","87":"community-edit","496":"font-modern","644":"font-traditional","763":"font-classic"}[chunkId] + "." + {"84":"8f2ad620a78d66f5","87":"18cba3abcd2433dd","496":"196529a146f6c805","644":"8541e1e364131368","763":"ba78011383e7f4db"}[chunkId] + ".js";
};